import { Modal, ShortcutHelp } from '@solinkcorp/solink-components';
import { withAspen } from 'components/aspen/withAspen';
import useLocale from 'src/hooks/useLocale';
import { KeyboardShortcutsDialogAspen } from './KeyboardShortcutsDialogAspen';

interface KeyboardShortcutsDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

function KeyboardShortcutsModal({ isOpen, onClose }: KeyboardShortcutsDialogProps) {
  const locale = useLocale();

  return (
    <Modal
      canConfirm={true}
      className="shortcuts-list"
      closeOnOutsideClick={true}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onClose}
      title={locale.keyboard.keyboardShortcuts}
      type="medium"
    >
      <div style={{ maxHeight: '80vh' }}>
        <ShortcutHelp />
      </div>
    </Modal>
  );
}

export const KeyboardShortcutsDialogGated = withAspen(
  KeyboardShortcutsModal,
  KeyboardShortcutsDialogAspen,
);
